export const OneDriveFileProviderDisplayName = "$jc";
export const OneDriveConsumerFileProviderDisplayName = "akc";
export default {OneDriveFileProviderDisplayName,OneDriveConsumerFileProviderDisplayName};